import { Box, Skeleton } from "@mui/material";
import React from "react";

const ItinerarySummarySkeleton = () => (
  <Box
    data-testid="itinerary-summary-skeleton-container"
    id="itinerary"
    className="anchor-section"
    sx={{
      display: "flex",
      padding: { xs: "2.4rem 0rem", legacyTablet: "4rem 0rem", legacyDesktop: "4rem 0rem" },
      gap: "3.2rem",
      justifyContent: "space-between",
      flexDirection: { xs: "column", legacyTablet: "column", legacyDesktop: "row" }
    }}
    data-track="visibility"
    data-parent-container-type="pdp"
    data-module-name="Itinerary Summary"
    data-ranking-algorithm="manual"
    data-module-ranking-position="4"
  >
    <Box
      data-testid="itinerary-content-section"
      sx={{
        display: "flex",
        gap: { xs: "2rem", md: "2.4rem" },
        flex: 1,
        alignItems: "flex-start",
        flexDirection: "column"
      }}
    >
      {/* Header Skeleton */}
      <Box
        data-testid="itinerary-header"
        sx={{
          display: "flex",
          gap: "2rem",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "flex-start"
        }}
      >
        <Skeleton
          variant="text"
          width={180}
          height={40}
          sx={{ fontSize: "28px", borderRadius: "0.4rem" }}
        />
        <Box
          data-testid="itinerary-actions"
          sx={{ display: "flex", gap: "1.8rem", alignItems: "center" }}
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </Box>
      <Box
        data-testid="itinerary-details"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { xs: "4rem", sm: "2.4rem", md: "4rem" }
        }}
      >
        {/* Summary Row Skeleton */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "34px" }}>
          {/* DAYS */}
          <Box
            sx={{
              paddingRight: "2.4rem",
              borderRight: (theme) => `1px solid ${theme.palette.divider}`,
              display: "flex",
              flexDirection: "column",
              gap: "0.8rem",
              minWidth: "7rem"
            }}
          >
            <Skeleton variant="text" width={40} height={16} sx={{ borderRadius: "0.2rem" }} />
            <Skeleton variant="text" width={32} height={24} sx={{ borderRadius: "0.2rem" }} />
          </Box>
          {/* NIGHTS */}
          <Box
            sx={{
              paddingRight: "2.4rem",
              borderRight: (theme) => `1px solid ${theme.palette.divider}`,
              display: "flex",
              flexDirection: "column",
              gap: "0.8rem",
              minWidth: "7rem"
            }}
          >
            <Skeleton variant="text" width={40} height={16} sx={{ borderRadius: "0.2rem" }} />
            <Skeleton variant="text" width={32} height={24} sx={{ borderRadius: "0.2rem" }} />
          </Box>
          {/* MEALS */}
          <Box
            sx={{
              paddingRight: "2.4rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.8rem",
              minWidth: "7rem"
            }}
          >
            <Skeleton variant="text" width={40} height={16} sx={{ borderRadius: "0.2rem" }} />
            <Skeleton variant="text" width={32} height={24} sx={{ borderRadius: "0.2rem" }} />
          </Box>
        </Box>
        {/* Date Info Skeleton */}
        <Box
          data-testid="itinerary-date-info-section"
          sx={{
            display: "flex",
            gap: "12px",
            flexDirection: { xs: "column", sm: "row", md: "column" },
            alignItems: "flex-start"
          }}
        >
          <Skeleton variant="text" width={200} height={28} sx={{ borderRadius: "0.2rem" }} />
          <Skeleton variant="rectangular" width={140} height={40} sx={{ borderRadius: "100px" }} />
        </Box>
        {/* Best time to travel Skeleton */}
        <Box data-testid="itinerary-best-time-to-travel">
          <Skeleton variant="text" width={200} height={28} sx={{ borderRadius: "0.2rem" }} />
          <Skeleton
            variant="text"
            width={120}
            height={28}
            sx={{ borderRadius: "0.2rem", marginTop: "0.8rem" }}
          />
        </Box>
      </Box>
    </Box>
    {/* Map Skeleton */}
    <Box
      sx={{
        width: "100%",
        maxWidth: "82rem",
        height: {xs: "300px", sm: "400px", md: "450px", lg: "486px"}
      }}
    >
      <Skeleton
        data-testid="itinerary-map-skeleton"
        variant="rectangular"
        width="100%"
        sx={{ borderRadius: "2rem", display: "block", height: "100%" }}
      />
    </Box>
  </Box>
);

export default ItinerarySummarySkeleton;
